import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';

import clienteService from '../../../service/administracion/clienteService';
import resumenDiario from '../../../service/ventas/resumenDiario';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import FormView from './FormView';
import CdrModal from './CdrModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            loadingSearch: false,
            viewVisible: false,
            loadingVer: false,
            cdrVisible: false,
            selectedItem: {},
            clientes: [],
            estados: [],
            viewFormValues: {},
            filter: {
                nombre: "",
                idEstado: 0,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),

                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: "",
            idCliente: 0,
            fechaDocumentosStr: global.fetchCurrentDateStr(),
            clientes: [],
            dataSource: [],
            selectedRowKeys: [],
            listaComprobanteReferencia: []
        }
    };

    handleClearFilters = () => {
        var filter = {
            nombre: "",
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            idEstado: 0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await resumenDiario.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Resumen Diario.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await resumenDiario.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Resumen Diario.pdf");
    }

    handleEmitir = async (item) => {
        dialog.confirm(
            `¿Desea enviar el comprobante ?`,
            async () => {
                var response = await resumenDiario.emitir({ id: item.id });

                if (response.status === 200) {
                    dialog.success(
                        `Comprobante ${item.correlativo} se genero correctamente.`
                    );
                    this._handlePagination(this.state.filter);
                    return;
                }

                if (response.status === 400) {
                    dialog.warning(
                        <ul>
                            {response.data.messages.map((item) => (
                                <li>{item}</li>
                            ))}
                        </ul>
                    );
                    return;
                }

                dialog.error(
                    "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
                );
            }
        );
    };


    handleConsultarTicket = async (item) => {
        dialog.confirm(
            `¿Desea consultar el estado de ticket ?`,
            async () => {
                var response = await resumenDiario.ticket({ id: item.id });

                if (response.status === 200) {
                    dialog.success(response.data);
                    this._handlePagination(this.state.filter);
                    return;
                }

                if (response.status === 400) {
                    dialog.warning(
                        <ul>
                            {response.data.messages.map((item) => (
                                <li>{item}</li>
                            ))}
                        </ul>
                    );
                    return;
                }

                dialog.error(
                    "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
                );
            }
        );
    };

    handleAnular = async (item) => {
        dialog.confirm(
            `¿Desea anular Resumen Diario ${item.correlativo}?`,
            async () => {
                var response = await resumenDiario.anular({ id: item.id });

                if (response.status === 200) {
                    dialog.success(
                        `Resumen Diario ${item.correlativo} anulado correctamente.`
                    );
                    this._handlePagination(this.state.filter);
                    return;
                }

                if (response.status === 400) {
                    dialog.warning(
                        <ul>
                            {response.data.messages.map((item) => (
                                <li>{item}</li>
                            ))}
                        </ul>
                    );
                    return;
                }

                dialog.error(
                    "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
                );
            }
        );
    };
    handleView = async (item) => {
        this.setState({ loadingVer: true });
        var response = await resumenDiario.ver({ id: item.id });
        if (response !== undefined) {

            this.setState({
                loadingVer: false,
                viewVisible: true,
                viewFormValues: response,
            });
        }
    };

    handleChangeView = (property, value) => {
        const formValues = { ...this.state.formValues, [property]: value };
        this.setState({ formValues });
    };
    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.clientes = this.state.clientes;

        this.setState({ visible: true, formValues });
    };

    handleEdit = async (values) => {
        const response = await resumenDiario.obtenerPorId(values.id);
        if (response !== undefined) {
            this.setState({
                visible: true,
                formValues: {
                    id: response.id,
                    nombre: response.nombre,
                    idEstablecimiento: response.idEstablecimiento,
                    clientes: this.state.clientes,
                    codigotipoEstablecimiento: values.codigotipoEstablecimiento
                }
            });
        }
    };

    handleSave = () => {

        if (this.state.formValues.listaComprobanteReferencia.length == 0) {
            message.error("Seleccione los comprobantes ");

            return false;
        }
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {

            var values = {
                id: this.state.formValues.id,
                Nombre: global.fetchUniqueCode(),
                fechaStr: this.state.formValues.fechaDocumentosStr,
                totalComprobantes: this.state.formValues.listaComprobanteReferencia.length,
                listaResumenDiarioDetalle: this.state.formValues.listaComprobanteReferencia,
            }

            var response;
            if (values.id === 0)
                response = await resumenDiario.registrar(values);
            else
                response = await resumenDiario.modificar(values);

            if (response.status === 200) {
                //form.resetFields();
                var formValues = this.fetchEmptyFormValues();

                this.setState({ visible: false, formValues });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleBuscar = async (data, form) => {
        this.setState({ loadingSearch: true });

        var filter = { ...this.state.filter };
        filter.page = 1;
        filter.idCliente = data.idCliente;
        filter.fechaDocumentosStr = data.fechaDocumentosStr;
        filter.pageSize = 30;


        var response = await resumenDiario.importarRegistrados(filter);
        this.setState({
            formValues: {
                ...this.state.formValues,
                dataSource: response,
                selectedRowKeys: this.state.formValues.listaComprobanteReferencia.map(function (v) {
                    return v.serie + '-' + v.documento;
                })
            },
        });
        this.setState({ loadingSearch: false });



    };

    handleSelect = (selected, rows) => {

        message.success("Se agrego " + rows.length + " Comprobates");

        var listaComprobanteReferencia = [];
        rows.forEach(row => {
            var item = {
                identifier: global.fetchUniqueCode(),
                documento: row.documento,
                fechaStr: row.fechaStr,
                idComprobante: row.id,
                idCliente: row.idCliente,
                idMoneda: row.idMoneda,
                idTipoComprobante: row.idTipoComprobante,
                nombreTipoComprobante: row.nombreTipoComprobante,
                razonSocialCliente: row.razonSocialCliente,
                serie: row.serie,
                serieDocumento: row.serieDocumento,
                serieReferencia: row.serieReferencia,
                documentoReferencia: row.documentoReferencia,
                tipoDocumentoReferencia: row.tipoDocumentoReferencia,
                porcentajeIGV: row.porcentajeIGV,
                totalDetalleISC: row.totalDetalleISC,
                totalDetalleAfecto: row.totalDetalleAfecto,
                totalDetalleInafecto: row.totalDetalleInafecto,
                totalDetalleGratuito: row.totalDetalleGratuito,
                totalDetalle: row.totalDetalle,
                totalDetalleExportacion: row.totalDetalleExportacion,
                importeDescuento: row.importeDescuento,
                subTotal: row.subTotal,
                igv: row.igv,
                total: row.total,
                porcentajeDetraccion: row.porcentajeDetraccion,
                porcentajePercepcion: row.porcentajePercepcion,
                importeDetraccion: row.importeDetraccion,
                importePercepcion: row.importePercepcion,
                totalDetraccion: row.totalDetraccion,
                totalPercepcion: row.totalPercepcion,
                totalDetalleExonerado: row.totalDetalleExonerado,
                porcentajeRetencion: row.porcentajeRetencion,
                importeRetencion: row.importeRetencion,
                totalRetencion: row.totalRetencion,
                importeDescuentoGlobal: row.importeDescuentoGlobal,
                porcentajeDescuentoGlobal: row.porcentajeDescuentoGlobal,
            };
            listaComprobanteReferencia.push(item)

        });

        listaComprobanteReferencia = listaComprobanteReferencia.filter(m => selected.filter(f => f === m.serieDocumento).length);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia,
                selectedRowKeys: selected
            },

        });


    };

    handleOpenCdrModal = async (row) => {
        this.setState({
            cdrVisible: true,
            selectedItem: row,
        });
    };

    handleDownloadXml = async () => {
        var response = await resumenDiario.xml({
            id: this.state.selectedItem.id,
        });
        if (response !== undefined)
            global.dowloadFile(response.data, this.state.selectedItem.nombreXML);
    };

    handleDownloadCdr = async () => {
        var response = await resumenDiario.cdr({
            id: this.state.selectedItem.id,
        });
        if (response !== undefined)
            global.dowloadFile(response.data, this.state.selectedItem.nombreCDR);
    };


    handleSearchPag = async (page, order, field) => {

        this.setState({ loadingSearch: true });
        var filter = { ...this.state.filter };
        filter.page = page.page;
        filter.idCliente = this.state.formValues.idCliente;
        filter.fechaDocumentosStr = this.state.formValues.fechaDocumentosStr;
        filter.pageSize = 30;


        var response = await resumenDiario.importarRegistrados(filter);
        this.setState({
            formValues: {
                ...this.state.formValues,
                dataSource: response,
                selectedRowKeys: this.state.formValues.listaComprobanteReferencia.map(function (v) {
                    return v.serie + '-' + v.documento;
                })
            },
        });
        this.setState({ loadingSearch: false });


    };


    async componentDidMount() {
        this._initPagination(this.state.filter, resumenDiario.paginacion);
        const clientes = await clienteService.listar();
        const estado = await resumenDiario.listarEstado();

        this.setState({
            loadingSource: false,
            clientes: clientes ? clientes : [],
            estados: estado ? estado : [],

        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Resumen Diario"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    clientes={this.state.clientes}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingVer={this.state.loadingVer}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onEdit={this.handleEdit}
                    onView={this.handleView}
                    onEmitir={this.handleEmitir}
                    onTicket={this.handleConsultarTicket}
                    onAnular={this.handleAnular}
                    onChange={this._handleChangePagination}
                    onCdr={this.handleOpenCdrModal}

                />
                <FormModal
                    visible={this.state.visible}
                    loadingSearch={this.state.loadingSearch}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onBuscar={this.handleBuscar}
                    onSelect={this.handleSelect}
                    onChange={this.handleSearchPag}
                    handleChangeView={this.handleChangeView}

                />
                <CdrModal
                    visible={this.state.cdrVisible}
                    item={this.state.selectedItem}
                    onDownloadXml={this.handleDownloadXml}
                    onDownloadCdr={this.handleDownloadCdr}
                    onClose={() => this.setState({ cdrVisible: false })}
                />
                <FormView
                    visible={this.state.viewVisible}
                    formValues={this.state.viewFormValues}
                    onClose={() => this.setState({ viewVisible: false })}
                />
            </div>
        );
    };
}